export const EXPORT_MESSAGE_BY_STATUS = {
  SUCCESS: 'Successfully exported CSV',
  ERROR: 'Failed to export CSV',
}
